import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/auth/utils";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // dashboard page
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/pages/Dashboard.vue"),
      meta: {
        pageTitle: "Dashboard",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Dashboard",
            icon: "bi bi-columns-gap",
            active: true,
          },
        ],
      },
    },
    {
      path: "/dashboard-social-media",
      name: "dashboard-social-media",
      component: () => import("@/views/pages/DashboardSocialMedia.vue"),
      meta: {
        pageTitle: "Dashboard Social Media",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Dashboard Social Media",
            icon: "bi bi-phone",
            active: true,
          },
        ],
      },
    },

    // online news page
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/pages/online-news/ErrorLogs.vue"),
      meta: {
        pageTitle: "Error",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Error Logs",
            icon: "bi bi-x-circle",
            active: true,
          },
        ],
      },
    },
    {
      path: "/redirected",
      name: "redirected",
      component: () => import("@/views/pages/online-news/RedirectedLogs"),
      meta: {
        pageTitle: "Redirected",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Redirected Logs",
            icon: "bi bi-repeat",
            active: true,
          },
        ],
      },
    },
    {
      path: "/unavailable",
      name: "unavailable",
      component: () => import("@/views/pages/online-news/UnavailableLogs"),
      meta: {
        pageTitle: "Unavailable",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Unavailable Logs",
            icon: "bi bi-slash-circle",
            active: true,
          },
        ],
      },
    },
    {
      path: "/missingclass",
      name: "missingclass",
      component: () => import("@/views/pages/online-news/MissingClassLogs"),
      meta: {
        pageTitle: "Missing Class",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Missing Class Logs",
            icon: "bi bi-exclamation-circle",
            active: true,
          },
        ],
      },
    },
    {
      path: "/detail-logs",
      name: "detail-logs",
      component: () => import("@/views/pages/ScraperDetail.vue"),
      meta: {
        pageTitle: "Detail Scraper",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Detail Scraper",
            icon: "bi bi-journal-text",
            active: true,
          },
        ],
      },
    },
    {
      path: "/no-article",
      name: "no-article",
      component: () => import("@/views/pages/online-news/NoArticleLogs.vue"),
      meta: {
        pageTitle: "No Article",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "No Article",
            icon: "bi bi-file-earmark-x",
            active: true,
          },
        ],
      },
    },
    {
      path: "/no-content",
      name: "no-content",
      component: () => import("@/views/pages/online-news/NoContentLogs.vue"),
      meta: {
        pageTitle: "No Content",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "No Content",
            icon: "bi bi-journal-x",
            active: true,
          },
        ],
      },
    },
    
    {
      path: "/no-journalist",
      name: "no-journalist",
      component: () => import("@/views/pages/online-news/NoJournalistLogs.vue"),
      meta: {
        pageTitle: "No Journalist",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "No Jpurnalist",
            icon: "bi bi-person-x",
            active: true,
          },
        ],
      },
    },
    {
      path: "/related-link",
      name: "related-link",
      component: () => import("@/views/pages/online-news/RelatedLinkLogs.vue"),
      meta: {
        pageTitle: "Related Link",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Related Link",
            icon: "bi bi-link-45deg",
            active: true,
          },
        ],
      },
    },
    {
      path: "/invalid-date",
      name: "invalid-date",
      component: () => import("@/views/pages/online-news/InvalidDate.vue"),
      meta: {
        pageTitle: "Invalid Date",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Invalid Date",
            icon: "bi bi-calendar-x",
            active: true,
          },
        ],
      },
    },
    {
      path: "/invalid-date-detail",
      name: "invalid-date-detail",
      component: () =>
        import("@/views/pages/online-news/InvalidDateDetail.vue"),
      meta: {
        pageTitle: "Invalid Date Detail",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Invalid Date Detail",
            icon: "bi bi-calendar-x",
            active: true,
          },
        ],
      },
    },
    {
      path: "/fixing",
      name: "fixing",
      component: () => import("@/views/pages/online-news/Fixing.vue"),
      meta: {
        pageTitle: "Fixing",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Fixing",
            icon: "bi bi-tools",
            active: true,
          },
        ],
      },
    },
    {
      path: "/delay-data",
      name: "delay-data",
      component: () => import("@/views/pages/online-news/DelayData.vue"),
      meta: {
        pageTitle: "Delay Data",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Delay Data",
            icon: "bi bi-clock-history",
            active: true,
          },
        ],
      },
    },
    {
      path: "/delay-data-detail",
      name: "delay-data-detail",
      component: () =>
        import("@/views/pages/online-news/DelayDataDetail.vue"),
      meta: {
        pageTitle: "Delay Data Detail",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Delay Data Detail",
            icon: "bi bi-clock-history",
            active: true,
          },
        ],
      },
    },

    // Social Media Pages
    {
      path: "/tiktok-logs",
      name: "tiktok-logs",
      component: () => import("@/views/pages/social-media/TiktokLogs.vue"),
      meta: {
        pageTitle: "Tiktok Logs",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Tiktok Logs",
            icon: "bi bi-tiktok",
            active: true,
          },
        ],
      },
    },
    {
      path: "/facebook-logs",
      name: "facebook-logs",
      component: () => import("@/views/pages/social-media/facebook/FacebookLogs.vue"),
      meta: {
        pageTitle: "Facebook Logs",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "facebook Logs",
            icon: "bi bi-facebook",
            active: true,
          },
        ],
      },
    },
    {
      path: "/facebook-logs-detail",
      name: "facebook-logs-detail",
      component: () => import("@/views/pages/social-media/facebook/FacebookLogsDetail.vue"),
      meta: {
        pageTitle: "Facebook Logs Detail",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "facebook Logs",
            icon: "bi bi-facebook",
            active: true,
          },
        ],
      },
    },
    
    {
      path: "/forum-logs",
      name: "forum-logs",
      component: () => import("@/views/pages/ForumLogs.vue"),
      meta: {
        pageTitle: "Forum Logs",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Forum Logs",
            icon: "bi bi-chat-fill",
            active: true,
          },
        ],
      },
    },
    {
      path: "/media-siputra",
      name: "media-siputra",
      component: () => import("@/views/pages/MediaSiputra.vue"),
      meta: {
        pageTitle: "Siputra",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Media Siputra",
            icon: "bi bi-globe2",
            active: true,
          },
        ],
      },
    },

    // {
    //   path: "/virtual-machine",
    //   name: "virtual-machine",
    //   component: () => import("@/views/pages/VirtualMachine.vue"),
    //   meta: {
    //     pageTitle: "Virtual Machine",
    //     auth: [0, 1, 2],
    //     breadcrumb: [
    //       {
    //         text: "Virtual Machine",
    //         icon: "bi bi-hdd-rack",
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: "/scraping-schedule",
      name: "scraping-schedule",
      component: () => import("@/views/pages/ScrapingSchedule.vue"),
      meta: {
        pageTitle: "Jadwal Scraping",
        auth: [0, 1, 2],
        breadcrumb: [
          {
            text: "Jadwal Scraping",
            icon: "bi bi-hdd-rack",
            active: true,
          },
        ],
      },
    },
    {
      path: "/log-scraper-tier-1",
      name: "log-scraper-tier-1",
      component: () => import("@/views/pages/LogScraperTier1.vue"),
      meta: {
        pageTitle: "Log Scraper Tier 1",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Log Scraper Tier 1",
            icon: "bi bi-card-list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/log-media-tier",
      name: "log-media-tier",
      component: () => import("@/views/pages/LogMediaTier.vue"),
      meta: {
        pageTitle: "Log Tier Media",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Log Tier Media",
            icon: "bi bi-card-list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/early-warning-system",
      name: "early-warning-system",
      component: () => import("@/views/pages/EarlyWarningSystem.vue"),
      meta: {
        pageTitle: "EWS Penghentian Scraper",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "EWS Penghentian Scraper",
            icon: "bi bi-exclamation-circle",
            active: true,
          },
        ],
      },
    },
    {
      path: "/scraper",
      name: "scraper",
      component: () => import("@/views/pages/master-data/Scraper.vue"),
      meta: {
        pageTitle: "Scraper Online News",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Scraper",
            icon: "bi bi-card-list",
            active: true,
          },
        ],
      },
    },
    {
      path: "/grafana",
      name: "grafana",
      component: () => import("@/views/pages/master-data/Grafana.vue"),
      meta: {
        pageTitle: "Grafana",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Grafana",
            icon: "bi bi-server",
            active: true,
          },
        ],
      },
    },
    {
      path: "/problem-classification",
      name: "problem-classification",
      component: () => import("@/views/pages/master-data/ProblemClassification.vue"),
      meta: {
        pageTitle: "Klasifikasi Masalah",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Klasifikasi Masalah",
            icon: "bi bi-server",
            active: true,
          },
        ],
      },
    },
    {
      path: "/users",
      name: "users",
      component: () => import("@/views/pages/master-data/User.vue"),
      meta: {
        pageTitle: "Users",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Users",
            icon: "bi bi-person-lines-fill",
            active: true,
          },
        ],
      },
    },
    {
      path: "/smd-users",
      name: "smd-users",
      component: () => import("@/views/pages/master-data/SmdUser.vue"),
      meta: {
        pageTitle: "User Sosmed",
        auth: [0],
        breadcrumb: [
          {
            text: "User Sosmed",
            icon: "bi bi-person-badge",
            active: true,
          },
        ],
      },
    },
    {
      path: "/wordpress",
      name: "wordpress",
      component: () => import("@/views/pages/master-data/Wordpress.vue"),
      meta: {
        pageTitle: "Wordpress",
        auth: [0, 1],
        breadcrumb: [
          {
            text: "Wordpress",
            icon: "bi bi-wordpress",
            active: true,
          },
        ],
      },
    },

    // login page
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/pages/Login.vue"),
      meta: {
        pageTitle: "Login",
        layout: "full",
        resource: "Auth",
        redirectIfLoggedIn: true,
      },
    },

    // error page
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/pages/Error404.vue"),
      meta: {
        pageTitle: "Error Not Found",
        layout: "full",
        auth: [0, 1, 2],
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name !== "login") {
    const isLoggedIn = isUserLoggedIn();
    if (!isLoggedIn) return next({ name: "login" });

    const userRole = Number(store.getters["data/user"].role);
    const canAccess = to.meta.auth ? (userRole === 0 || to.meta.auth.includes(userRole)) : true;
    if (canAccess == false) {
      return next({ name: "error-404" });
    }
  }

  return next();
});

router.afterEach((to) => {
  document.title = `${to.meta.pageTitle} | MONSCRAP`;
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
